//
//
//
//
//
//

import FranchiseNav from "~/components/franchising/FranchiseNav.vue"

export default {
  async asyncData({ $storyblok, params }) {
    const page = await $storyblok.getPage(`pages/perks/${params.slug}`)
    return {
      page: page
    }
  },
  head() {
    return this.$metadata(this.page)
  },
}
